import {postJson,downloadAttachment} from "@/utils/http";
import {SYS_APi_SCREENING_URL} from '@/utils/globals'

// 商户列表分页查询
export const pageQuery = p => postJson(SYS_APi_SCREENING_URL + "/newMerchant/pageQuery", p);

// 商户列表分页查询
export const pageQueryList = p => postJson(SYS_APi_SCREENING_URL + "/newMerchant/pageQueryList", p);

// 门店列表分页查询
export const pageQueryStore = p => postJson(SYS_APi_SCREENING_URL + "/newStore/pageQuery", p);

// 导出
export const exportExcel = p => downloadAttachment(SYS_APi_SCREENING_URL + "/newMerchant/export", p);

// 商户管理下级门店分页查询
export const subPageQuery = p => postJson(SYS_APi_SCREENING_URL + "/newStore/subPageQuery", p);